"use client";

import { useRef, useEffect } from "react";
import { YOUZU_API_BASE_URL } from "@/constants/api";
import { createAccessToken } from "@/services/token.service";

interface YouzuSwapSDKProps {
  catalogueId?: string;
}

export function YouzuSwapSDK({ catalogueId }: YouzuSwapSDKProps) {
  const swapRef = useRef<any>(null);

  useEffect(() => {
    const swap = swapRef.current;
    if (!swap) return;

    if (catalogueId) {
      swap.setAttribute("catalogue-id", catalogueId);
    } else {
      swap.removeAttribute("catalogue-id");
    }

    // Token for detection + near-space product search (includes catalogueId)
    swap.resolveToken = async () => {
      try {
        return await createAccessToken({ catalogueId });
      } catch (error) {
        console.error("Failed to resolve token:", error);
        return null;
      }
    };

    // Token for creating swap jobs
    swap.resolveSwapToken = async () => {
      try {
        return await createAccessToken();
      } catch (error) {
        console.error("Failed to resolve swap token:", error);
        return null;
      }
    };

    // Token for reading swap status
    swap.resolveSwapReadToken = async () => {
      try {
        return await createAccessToken();
      } catch (error) {
        console.error("Failed to resolve swap read token:", error);
        return null;
      }
    };

    const handleSwapComplete = (e: any) => {
      console.log("Swap complete:", e.detail?.outputUrl);
    };

    swap.addEventListener("swap.complete", handleSwapComplete);
    return () => {
      swap.removeEventListener("swap.complete", handleSwapComplete);
    };
  }, [catalogueId]);

  return (
    <youzu-swap
      ref={swapRef}
      api-base-url={YOUZU_API_BASE_URL}
      style={{ display: "block", width: "100%", height: "600px" }}
    />
  );
}
